import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import PublicRoute from "./navigation/PublicRoute";
import ProtectedRoute from "./navigation/ProtectedRoute";
import { AuthProvider } from "./navigation/AuthProvider";

import AdminBillingPage from "./screens/admin/AdminBilligaPage"; // Importera admin-sidan
import { Dashboard } from "./screens/protected/Dashboard";
import { Login } from "./screens/public/Login";
import { Home } from "./screens/public/Home";
import { SetPassword } from "./screens/public/SetPassword";
import { Employees } from "./screens/protected/Employees";
import { Projects } from "./screens/protected/Projects";
import { Shift } from "./screens/protected/Shift";
import { Customers } from "./screens/protected/Customers";
import Payroll from "./screens/protected/Payroll";
import { Business } from "./screens/protected/Business";
import { ResetPassword } from "./screens/public/ResetPassword";
import { CreateCompany } from "./screens/public/CreateCompany";
import { ProjectOverview } from "./screens/protected/ProjectOverview";
import { ObOverview } from "./screens/protected/ObOverview";
import AbsenceOverview from "./screens/protected/AbsenceOverview";
import OvertimeOverview from "./screens/protected/OvertimeOverview";
import OvertimeRequests from "./screens/protected/OvertimeRequests";
import AbsenceRequests from "./screens/protected/AbsenceRequests";
import ProjecGroups from "./screens/protected/ProjectGroups";
import ExportPay from "./screens/protected/ExportPay";
import RoleInformation from "./screens/protected/RoleInformation";
import Subscription from "./screens/protected/Subscription";
import {CompanySettings} from "./screens/protected/CompanySettings";

import {SystemAdminLogin} from "./screens/public/SystemAdminLogin"; // Importera systemadmin-login

// TIME SMART+ IMPORTS - vi har bara dessa två filer
import TimeSmartInvoice from "./components/TimeSmartInvoice";
import TimeSmartTimeReport from "./components/TimeSmartTimeReport";

// IMPORTERA RAPPORTSIDAN
import Reports from "./screens/protected/Reports";
import Notices from "./screens/protected/Notices";
import History from "./screens/protected/History";

import "./screens/css/global/permissions.css";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>

          {/* Public routes */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route
            path="/7hGk92Lm/admin"
            element={
              <PublicRoute
                restricted={false}
                element={<AdminBillingPage />}
              />
            }
          />
          <Route
            path="/login"
            element={<PublicRoute restricted={true} element={<Login />} />}
          />
          <Route
            path="/set-password"
            element={<PublicRoute restricted={true} element={<SetPassword />} />}
          />
          <Route
            path="/reset-password"
            element={<PublicRoute restricted={true} element={<ResetPassword />} />}
          />
          <Route
            path="/create-company"
            restricted={true}
            element={<CreateCompany />}
          />
          <Route
            path="/system-admin/login"
            element={<PublicRoute restricted={true} element={<SystemAdminLogin />} />}
          />

          {/* Protected routes */}

          <Route
            path="/shifts"
            element={<ProtectedRoute capability="schedule" element={<Shift />} />}
          />

          <Route
            path="/employees"
            element={<ProtectedRoute capability="employees" element={<Employees />} />}
          />

          <Route
            path="/projects"
            element={<ProtectedRoute capability="projects" element={<Projects />} />}
          />

          <Route
            path="/project-overview"
            element={<ProtectedRoute capability="projects:overview" element={<ProjectOverview />} />}
          />

          <Route
            path="/project-groups"
            element={<ProtectedRoute capability="projects:groups" element={<ProjecGroups />} />}
          />

          <Route
            path="/customers"
            element={<ProtectedRoute capability="customers" element={<Customers />} />}
          />

          {/* RAPPORTER ROUTE - NY */}
          <Route
            path="/reports"
            element={<ProtectedRoute capability="reports" element={<Reports />} />}
          />

          {/* ANSLAGSTAVLA */}
          <Route
            path="/notices"
            element={<ProtectedRoute capability="notices" element={<Notices />} />}
          />

          {/* TIME SMART+ ROUTES */}
          <Route
            path="/timesmart-invoice"
            element={<ProtectedRoute capability="timesmart" element={<TimeSmartInvoice />} />}
          />

          <Route
            path="/timesmart-timereport"
            element={<ProtectedRoute capability="timesmart" element={<TimeSmartTimeReport />} />}
          />

          {/* PROJEKTFAKTUROR - använder samma komponent som TimeSmart+ faktura eller en separat */}
          <Route
            path="/invoices"
            element={<ProtectedRoute capability="projects:overview" element={<TimeSmartInvoice />} />}
          />

          <Route
            path="/invoices/:invoiceId"
            element={<ProtectedRoute capability="projects:overview" element={<TimeSmartInvoice />} />}
          />

          <Route
            path="/payroll"
            element={<ProtectedRoute capability="payroll" element={<Payroll />} />}
          />

          <Route
            path="/ob-overview"
            element={<ProtectedRoute capability="payroll:ob" element={<ObOverview />} />}
          />

          <Route
            path="/absence-overview"
            element={<ProtectedRoute capability="payroll:absence" element={<AbsenceOverview />} />}
          />

          <Route
            path="/overtime-overview"
            element={<ProtectedRoute capability="payroll:overtime" element={<OvertimeOverview />} />}
          />

          <Route
            path="/export-payroll"
            element={<ProtectedRoute capability="payroll:export" element={<ExportPay />} />}
          />

          <Route
            path="/overtime-requests"
            element={<ProtectedRoute capability="cases:overtime" element={<OvertimeRequests />} />}
          />

          <Route
            path="/absence-requests"
            element={<ProtectedRoute capability="cases:absence" element={<AbsenceRequests />} />}
          />

          <Route
            path="/business"
            element={<ProtectedRoute capability="settings:company" element={<Business />} />}
          />

          <Route
            path="/company-settings"
            element={<ProtectedRoute capability="settings:companySettings" element={<CompanySettings />} />}
          />

          <Route
            path="/role-information"
            element={<ProtectedRoute capability="settings:roles" element={<RoleInformation />} />}
          />
          {/* HISTORIK – åtkomst per person (superadmin väljer). Servern avgör; sidan visar låsskärm utan åtkomst. */}
          <Route
            path="/history"
            element={<ProtectedRoute element={<History />} />}
          />
          <Route
            path="/subscription"
            element={<ProtectedRoute capability="settings:subscription" element={<Subscription />} />}
          />

        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
